import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  trialEndsReminder: {
    id: 'Trial.TrialReminder.trialEndsReminder',
    defaultMessage:
      "Your trial ends in {daysLeft} day(s)! Don't miss out on the full experience. Contact us for more information."
  },
  trialClientsReminder: {
    id: 'Trial.TrialReminder.trialClientsReminder',
    defaultMessage:
      'You have created {clientsCreated} client(s). Trial only allows up to {maxClients} clients.'
  }
});
